import React, { useState } from "react";
import { QuizHeader, CardMedia, resolveImage, gridCols } from "./shared";

const TabbedImageSelectStep = ({ step, tabs, productsByTab, onAnswer, prevStep, stepLabel }) => {
  const [activeTab, setActiveTab] = useState(tabs?.[0]?.id);
  const products = productsByTab?.[activeTab] || [];

  return (
    <section className="qz-step">
      <QuizHeader
        title={step.question}
        subtitle={step.subtitle}
        stepLabel={stepLabel}
        onBack={prevStep}
      />

      <div className="qz-tabs-wrap">
        <div className="qz-tabs" role="tablist">
          {tabs?.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.id}
              className={`qz-tab ${activeTab === tab.id ? "is-active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      {products.length === 0 ? (
        <p className="qz-empty">No lenses to show here yet. Try another type above.</p>
      ) : (
        <div className="qz-grid qz-grid--fit" style={{ "--qz-cols": gridCols(products.length) }}>
          {products.map((product) => (
            <button
              key={product.id}
              type="button"
              className="qz-card"
              onClick={() =>
                onAnswer({ disposability: activeTab, product: { id: product.id, name: product.name } })
              }
            >
              <CardMedia src={resolveImage(product)} alt={product.name} />
              <span className="qz-card__name">{product.name}</span>
            </button>
          ))}
        </div>
      )}
    </section>
  );
};

export default TabbedImageSelectStep;